import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'styled-components';
import VersionListGroup from './VersionListGroup';
import { sortByGroup } from '../../utils/sort-list-util';
import { add, remove, shuffleLock, shuffleLockAll } from '../../actions/versionActions';
import { MAX_SCRIPT_NAME_LENGTH } from '../../constants/print-export';


const SCRIPT_NAME_PLACEHOLDER = 'Script Name';
const SCRIPT_AUTHOR_PLACEHOLDER = 'Author';

const HeaderContainer = styled.div`
position: sticky;
top: 0;
left: 0;
right: 0;
display: flex;
align-items: center;
background-color: #fff;
margin-left: auto; 
margin-right: auto; 
// height: ${props => props.isZoomed ? '70px' : '8%'};
padding-bottom: 10px;
z-index: 20;
`;

const Header = styled.div`
display: flex;
align-items: baseline;
gap: 8px;
padding: 1% 20px 0;
width: 100%;
`;

const EditButton = styled.button`
width: 33px;
height: 33px;
background-color: #F5F5F5;
color: #9E9E9E;
border-radius: 2px;
border: 0;
margin-right: 8px;
`;

const ScriptName = styled.button`
font-family: 'Dumbledor';
font-size: 16px;
text-transform: uppercase;
color: var(--botc-colour-ink-wineberry);
border: none;
background-color: transparent;
`;

const NameSeparator = styled.span`
color: #BDBDBD;
`;

const ScriptAuthor = styled.button`
color: var(--botc-colour-ink-wineberry);
border: none;
background-color: transparent;
`;

const DoneButton = styled.button`
color: #B89647;
font-family: 'Trade Gothic LT Std';
font-size: 16px;
text-decoration-line: underline;
background-color: transparent;
border: none;
`;

const ScriptField = styled.input`
font-family: 'Trade Gothic LT Std';
font-size: 16px;
border: solid 1px #CCB898;
flex: 1;
height: 30px;
color: var(--botc-colour-ink-wineberry);
padding: 12px;
min-width: 0;
width: 0;
`;

const InnerContainer = styled.div`
background-color: #fff;
box-shadow: 0 1px 6px -2px rgba(0, 0, 0, 0.3);
aspect-ratio: 210 / 287;
height: ${props => props.isZoomed ? 'auto' : '100%'};
width: ${props => props.isZoomed ? '920px' : 'auto'};
padding-bottom: ${props => props.isZoomed ? '30px' : '0'};
min-height: 700px;
max-height: ${props => props.isZoomed ? 'none' : '1300px'};
margin-left: auto;
margin-right: auto;
`;

const DecorationsContainer = styled(InnerContainer)`
background-color: transparent;
box-shadow: none;
height: 100dvh;
position: relative;
width: ${props => props.isZoomed ? '950px' : 'auto'};
${props => props.isZoomed && 'aspect-ratio: auto' };
`;

const Decoration1 = styled.div`
background-image: url('./images/website/decoration-1.webp');
position: absolute;
left: -160px;
top: -74px;
width: 365px;
height: 460px;
pointer-events: none;
`;

const Decoration2 = styled.div`
background-image: url('./images/website/decoration-2.webp');
position: absolute;
right: -142px;
bottom: 30px;
width: 394px;
height: 576px;
pointer-events: none;
`;

class VersionList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      roleList: this.props.roleList,
      isEditMode: false,
      scriptAuthor: '',
      scriptName: '',
    };
  }

  UNSAFE_componentWillReceiveProps(props) {
    //Receive updated role list (because of filtering or otherwise).
    if (props.roleList && props.roleList !== this.state.roleList) {
      this.setState({
        roleList: props.roleList
      });
    }

    this.handleEditStart = this.handleEditStart.bind(this);
    this.handleEditDone = this.handleEditDone.bind(this);
    this.handleEditDiscard = this.handleEditDiscard.bind(this);
    this.handleEditFieldKeyUp = this.handleEditFieldKeyUp.bind(this);
    this.handleChangeScriptAuthor = this.handleChangeScriptAuthor.bind(this);
    this.handleChangeScriptName = this.handleChangeScriptName.bind(this);
  }

  handleChangeScriptAuthor(e) {
    this.setState({ scriptAuthor: e.target.value });
  }

  handleChangeScriptName(e) {
    this.setState({ scriptName: e.target.value });
  }

  handleEditStart() {
    this.setState({
      isEditMode: true,
      scriptAuthor: this.props.scriptAuthor,
      scriptName: this.props.scriptName,
    });
  }

  handleEditDone() {
    this.setState({ isEditMode: false });
    this.props.changeScriptAuthor(this.state.scriptAuthor);
    this.props.changeScriptName(this.state.scriptName);
  }

  handleEditDiscard() {
    this.setState({ isEditMode: false, scriptAuthor: this.props.scriptAuthor, scriptName: this.props.scriptName });
  }

  handleEditFieldKeyUp(e) {
    switch (e.key) {
      case 'Enter':
        this.handleEditDone();
        break;
      case 'Escape':
        this.handleEditDiscard();
        break;
    }
  }

  addRole(role) {
    console.log('add', role);
    add(role);
  }

  removeRole(role) {
    console.log('renmove', role);
    remove(role);
  }

  shuffleLock(role) {
    shuffleLock(role);
  }

  shuffleLockAll() {
    shuffleLockAll(!this.props.isLocked);
  }

  render() {
    let displayRoles = [];

    if (this.state.roleList.length === 0) {
      displayRoles = <div className="version-list__group version-list__group--empty">
        <h4 className="version-list__header">No characters yet...</h4>
      </div>;
    }
    else {
      const roleListGrouped = sortByGroup(this.state.roleList, 'roleType');

      for (const roleList in roleListGrouped) {
        displayRoles.push(
          <VersionListGroup
            key={'role_' + roleList}
            roleList={roleListGrouped[roleList]}
            roleListName={roleList}
            removeRole={this.removeRole}
            addRole={this.addRole}
            shuffleLock={this.shuffleLock}
            isZoomed={this.props.isZoomed}
          />
        );
      }
    }

    return <div id="version-list-container" className={classNames("main__version-list-container",
      {"main__version-list-container--action-collapsed": !this.props.isActionBarExpanded}
    )}>
      <div className={classNames(
      "main__version-list"
    )}>
        <DecorationsContainer isZoomed={this.props.isZoomed}>
          <Decoration1 />
          <Decoration2 />
        </DecorationsContainer>
        <div className={classNames('version-list', this.props.isZoomed && 'version-list--zoom')}>
          <InnerContainer isZoomed={this.props.isZoomed}>
            <HeaderContainer isZoomed={this.props.isZoomed}>
              {
                this.state.isEditMode ?
                  <Header>
                    <ScriptField
                      type="text"
                      onChange={this.handleChangeScriptName}
                      onKeyUp={this.handleEditFieldKeyUp}
                      value={this.state.scriptName}
                      placeholder={SCRIPT_NAME_PLACEHOLDER}
                      maxLength={MAX_SCRIPT_NAME_LENGTH}
                      />
                    <NameSeparator>by</NameSeparator>
                    <ScriptField
                      type="text"
                      onChange={this.handleChangeScriptAuthor}
                      onKeyUp={this.handleEditFieldKeyUp}
                      value={this.state.scriptAuthor}
                      placeholder={SCRIPT_AUTHOR_PLACEHOLDER}
                      maxLength={50}
                    />
                    <DoneButton onClick={this.handleEditDone}>Done</DoneButton>
                  </Header>
                  :
                  <Header isZoom={this.props.isZoomed}>
                    <EditButton onClick={this.handleEditStart} title="Edit script name and/or author"><span className="glyphicon glyphicon-pencil" /></EditButton>
                    <ScriptName onClick={this.handleEditStart}>{this.props.scriptName || SCRIPT_NAME_PLACEHOLDER}</ScriptName>
                    <NameSeparator>by</NameSeparator>
                    <ScriptAuthor onClick={this.handleEditStart}>{this.props.scriptAuthor || SCRIPT_AUTHOR_PLACEHOLDER}</ScriptAuthor>
                  </Header>
              }
            </HeaderContainer>
          {/* hide the lock-all functionality -- redesign doesn't show this feature, but will keep it around just in case
          <div className={classNames(
            "version-list__lock",
            {
              "version-list__lock--checked": this.props.isLocked,
              "version-list__lock--hide": this.props.roleList.length <= 0
            })}>
            <input type="checkbox" checked={this.props.isLocked} onChange={() => this.shuffleLockAll()}/>
            <label></label>
          </div> */}

            {displayRoles}

            <div className="version-list__footer">
              *Not the 1st night
            </div>
          </InnerContainer>
        </div>
      </div>
    </div>
  }
}

VersionList.propTypes = {
  roleList: PropTypes.array,
  isLocked: PropTypes.bool,
  isActionBarExpanded: PropTypes.bool,
  isZoomed: PropTypes.bool,
};

export default VersionList;
